import { render, staticRenderFns } from "./ModalDriversLicenceTypeEdit.vue?vue&type=template&id=daee32d8&"
import script from "./ModalDriversLicenceTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ModalDriversLicenceTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports